import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface DocumentosCompetenciaPayload {
  codigo: string;
  version: string;
  fecha_designacion: string; // YYYY-MM-DD
  fecha_vencimiento: string; // YYYY-MM-DD
  estado?: number;
  motivo_creacion?: string;
}

export interface DocumentosCompetencia {
  id?: number;
  codigo: string;
  version: string;
  fecha_designacion: string;
  fecha_vencimiento: string;
  estado: number;
  motivo_creacion?: string;
  fechacreacion?: string;
  fechamodificacion?: string | null;
}

export interface DocumentosCompetenciaResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class DocumentosCompetenciaService {
  private readonly apiUrl = `${environment.apiUrl}/api/documentos_competencia`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<DocumentosCompetencia[]> {
    return this.http.get<DocumentosCompetencia[]>(this.apiUrl, { withCredentials: true });
  }

  getById(id: number): Observable<DocumentosCompetencia> {
    return this.http.get<DocumentosCompetencia>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  create(payload: DocumentosCompetenciaPayload): Observable<DocumentosCompetenciaResponse> {
    return this.http.post<DocumentosCompetenciaResponse>(this.apiUrl, payload, { withCredentials: true });
  }

  update(id: number, payload: Partial<DocumentosCompetenciaPayload>): Observable<DocumentosCompetenciaResponse> {
    return this.http.put<DocumentosCompetenciaResponse>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  inactivar(id: number): Observable<DocumentosCompetenciaResponse> {
    return this.http.put<DocumentosCompetenciaResponse>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  activar(id: number): Observable<DocumentosCompetenciaResponse> {
    return this.http.put<DocumentosCompetenciaResponse>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true });
  }
}